import { useState, useEffect } from "react";

export function useSessionStorageState(key, initialValue) {
  const saved = sessionStorage.getItem(key);
  const [value, setValue] = useState(saved ? JSON.parse(saved) : initialValue);

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}
